import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.scss';
import ContactPersonList from './ContactPersonList';
import { fetchContactPersons } from '../../actions';
import ContactPersonEdit from '../ContactPersonEdit';

class ManageUsers extends Component {
  state = {
    showEditContatctPerson: false,
    selectedContactPerson: null,
  };

  componentDidMount() {
    const { onGetContactPersons } = this.props;
    onGetContactPersons();
    this.scrollref = React.createRef();
  }

  handleOpenContactPerson = contactPerson => {
    this.setState({
      showEditContatctPerson: true,
      selectedContactPerson: {
        ...contactPerson,
        editMode: !!contactPerson.ContactPersonIdentifier,
      },
    });
  };

  handleContactPersonModalClose = () => {
    this.setState({
      showEditContatctPerson: false,
      selectedContactPerson: null,
    });
  };

  render() {
    const { contactPersons } = this.props;
    const { showEditContatctPerson, selectedContactPerson } = this.state;
    return (
      <>
        {showEditContatctPerson && (
          <ContactPersonEdit
            {...selectedContactPerson}
            showModal={showEditContatctPerson}
            // onChange={this.handleChangeContactPerson}
            onHandleModal={this.handleContactPersonModalClose}
            // onHandleConfirm={this.handleConfirm}
          />
        )}
        <div className="col-12 px-0 mx-0 w-100">
          <ContactPersonList
            data={contactPersons}
            onAddEditcontactPerson={this.handleOpenContactPerson}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  const contactPersons = state.user.contactPersons || [];
  return {
    contactPersons,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onGetContactPersons: () => {
      dispatch(fetchContactPersons());
    },
  });

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
